import * as types from '../../actions/types';

const initialState = {
  comments: [],
  isLoading: false,
  error: null,
};

const blogComment = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BLOG_COMMENTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_BLOG_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: action.payload,
        isLoading: false,
        error: null,
      };
    case types.GET_BLOG_COMMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case types.CREATE_BLOG_COMMENT_SUCCESS:
    case types.UPDATE_BLOG_COMMENT_SUCCESS:
    case types.DELETE_BLOG_COMMENT_SUCCESS:
    case types.APPROVE_BLOG_COMMENT_SUCCESS:
    case types.REJECT_BLOG_COMMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default blogComment;